import { render, staticRenderFns } from "./UserSync.vue?vue&type=template&id=72342a1a&"
import script from "./UserSync.vue?vue&type=script&lang=js&"
export * from "./UserSync.vue?vue&type=script&lang=js&"
import style0 from "./UserSync.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72342a1a')) {
      api.createRecord('72342a1a', component.options)
    } else {
      api.reload('72342a1a', component.options)
    }
    module.hot.accept("./UserSync.vue?vue&type=template&id=72342a1a&", function () {
      api.rerender('72342a1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/System/User/UserSync.vue"
export default component.exports